import { render, staticRenderFns } from "./CardTotalEntity.vue?vue&type=template&id=397e95a1"
import script from "./CardTotalEntity.vue?vue&type=script&lang=js"
export * from "./CardTotalEntity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports